(function () {
  'use strict';

  angular
      .module('tfc.Nav')
      .directive('tfcCompileHtml', tfcCompileHtml);

  // @ngInject
  function tfcCompileHtml($compile) {
    return {
      restrict : 'A',
      link : function ($scope, $el, $attrs) {
        var childScope;
        $scope.$watch($attrs.tfcCompileHtml, function (html) {
          if (childScope) {
            childScope.destroy();
          }
          $el.contents().remove();
          $el.html(html);
          childScope = $scope.$new();
          $compile($el.contents())(childScope);
        });
      }
    };
  }
  
})();